function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59602",
    d: "M11.11 9.808a2.4 2.4 0 0 1-1.86-.856 2.433 2.433 0 0 1-1.86.856 2.4 2.4 0 0 1-1.86-.856 2.166 2.166 0 0 1-.223.231 2.4 2.4 0 0 1-1.868.61A2.493 2.493 0 0 1 1.25 7.285v-.528a3.542 3.542 0 0 1 .179-1.116L2.6 2.143a1.3 1.3 0 0 1 1.232-.893h10.836a1.3 1.3 0 0 1 1.235.893l1.168 3.5a3.542 3.542 0 0 1 .179 1.116v.528a2.493 2.493 0 0 1-2.173 2.508 2.381 2.381 0 0 1-1.868-.61 3.454 3.454 0 0 1-.238-.246 2.441 2.441 0 0 1-1.86.871zM3.832 2.366a.193.193 0 0 0-.179.127L2.493 5.99a2.433 2.433 0 0 0-.127.744v.528a1.369 1.369 0 0 0 1.168 1.4A1.3 1.3 0 0 0 4.971 7.39a.558.558 0 1 1 1.116 0 1.243 1.243 0 0 0 1.3 1.3 1.31 1.31 0 0 0 1.3-1.3.558.558 0 0 1 1.116 0 1.243 1.243 0 0 0 1.3 1.3 1.31 1.31 0 0 0 1.3-1.3.558.558 0 1 1 1.116 0 1.3 1.3 0 0 0 1.436 1.295 1.369 1.369 0 0 0 1.168-1.4v-.528a2.434 2.434 0 0 0-.127-.744l-1.161-3.5a.193.193 0 0 0-.179-.127z",
    transform: "translate(-1.25 -1.25)",
    style: {
      fill: "#0060e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59603",
    d: "M15.459 19.673H3.552a1.31 1.31 0 0 1-1.3-1.3v-7.087a.558.558 0 1 1 1.116 0v7.084a.186.186 0 0 0 .186.186h11.905a.186.186 0 0 0 .186-.186v-7.092a.558.558 0 1 1 1.116 0v7.092a1.31 1.31 0 0 1-1.302 1.303z",
    transform: "translate(-1.506 -3.673)",
    style: {
      fill: "#0060e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59604",
    d: "M13.517 20.831H8.308a.566.566 0 0 1-.558-.558v-3.721a1.31 1.31 0 0 1 1.3-1.3h3.721a1.31 1.31 0 0 1 1.3 1.3v3.721a.566.566 0 0 1-.558.558zm-4.651-1.116h4.093v-3.163a.186.186 0 0 0-.186-.186H9.052a.186.186 0 0 0-.186.186z",
    transform: "translate(-2.913 -4.831)",
    style: {
      fill: "#0060e5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeblue);
export default __webpack_public_path__ + "static/media/homeblue.97719a4f28c6de740893f9c761790d56.svg";
export { ForwardRef as ReactComponent };